// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__4qGke","errors":"Errors_errors__2K8IH"};